import * as React from 'react'
import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import { cn } from '../../lib/utils.js'
import PropTypes from 'prop-types'
import OutlineTickIcon from '../Icon/OutlineTickIcon'

const Checkbox = React.forwardRef(({ className, disabled, borderColor, color, ...props }, ref) => (
    <CheckboxPrimitive.Root
        ref={ref}
        disabled={disabled}
        style={{ borderColor: borderColor }}
        className={cn(
            'rounded-[2px] peer h-4 w-4 border border-primary shrink-0 shadow focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:text-primary-foreground',
            color ? `border-${color} text-${color}-foreground` : 'border border-primary',
            className
        )}
        {...props}>
        <CheckboxPrimitive.Indicator style={{ backgroundColor: color && color, borderColor: borderColor ? borderColor : 'hsl(var(--primary))' }} className={cn(`flex h-[100%] rounded-[0.5px] items-center w-[100%] justify-center text-current`, !color && 'border border-primary bg-primary' )}>
            <OutlineTickIcon />
        </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName

Checkbox.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string
}

export { Checkbox }
